import { render } from "./InternalOrderCancerOverallSurvival.vue?vue&type=template&id=b4620d62&scoped=true"
import script from "./InternalOrderCancerOverallSurvival.vue?vue&type=script&lang=js"
export * from "./InternalOrderCancerOverallSurvival.vue?vue&type=script&lang=js"

import "./InternalOrderCancerOverallSurvival.vue?vue&type=style&index=0&id=b4620d62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4620d62"]])

export default __exports__